<template>
  <div>
      <div class="header-item shipment-delay-f-right" v-if="enableSaveButton">
        <div class="title">Shipment Delay</div>
      <div class="btn-inline">
        <Button
          size="mini"
          type="primary"
          class="ml-0"
          @click="saveDropoffDetails(false)"
          >{{ $t("SAVE") }}</Button
        >
      </div>
    </div>
    <Form :inline="false" class="form-default form-triple mt-30 mr-10">
      <div class="form-item-group">
        <FormItem label="Shipment Delay">
          <Select
            v-model="selectedDelayReason"
            value-key="name"
            :placeholder="$t('INDENT_SELECT_VEHICLE_TYPE')"
            class="select-default"
            @change="onChangeVehicle"
          >
            <Option
              v-for="item in reasonsList"
              :key="item.id"
              :label="item.name"
              :value="item"
            >
            </Option>
          </Select>
        </FormItem>
        <FormItem
          label="Comments"
          required
          v-if="selectedDelayReason === 'Others'"
        >
          <Input
            placeholder="Please enter comments for delay"
            size="mini"
            v-model="delayReasonComment"
          ></Input>
        </FormItem>
        <FormItem label="Delay In Hours" required>
          <Input
            placeholder="Please input delay in hours"
            size="mini"
            v-model="delayInHours"
          ></Input>
        </FormItem>
      </div>
    </Form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ShipmentDelay',
  props: {
    order: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      reasonsList: [],
      fieldsList: [],
      selectedDelayReason: null,
      delayInHours: null,
      delayReasonComment: null,
    };
  },
  async created() {
    const payload = {
      type: 'SHIPMENT_DELAY',
      depot_id: this.order.sources[0].location_id,
      movement: this.order.movement,
    };

    const result = await this.$store.dispatch(
      'indents/getReasonSettings',
      payload,
    );

    if (result.error) {
      this.$error({ message: result.error });
    } else if (result.data) {
      const reasons = [...result.data, 'Others'] || [];

      this.reasonsList = reasons;
    } else {
      this.$error({ message: this.$getErr('APP_CATCH_ERR') });
    }
    const orderShipmentDelay = this.order.shipment_delay || null;
    this.selectedDelayReason = orderShipmentDelay[orderShipmentDelay.length - 1].reason || null;
    this.delayInHours = orderShipmentDelay[orderShipmentDelay.length - 1].delayTime || null;
    this.delayReasonComment = orderShipmentDelay[orderShipmentDelay.length - 1].comment || null;
  },
  computed: {
    ...mapGetters({
      currentClient: 'app/currentClient',
      configurations: 'app/configurations',
      filter: 'mdm/filter',
      docks: 'app/docks',
      bootstrapData: 'app/bootstrapData',
      currentUser: 'app/currentUser',
    }),
    enableSaveButton() {
      return true;
    },
  },
  methods: {
    async saveDropoffDetails() {
      if (this.checkValidationStatus()) {   
        const payload = {
          orderId: this.order._id,
          orderNo: this.order.order_no,
          delayReason: this.selectedDelayReason,
          delayInHours: this.delayInHours,
          delayReasonComment: this.delayReasonComment,
        };
        const result = await this.$store.dispatch(
          'indents/saveShipmentDelay',
          payload,
        );

        if (result.error) {
          this.$error({ message: result.error });
        } else if (result.data) {
          this.$success({ message: 'Shipment Delay Saved Successfully' });
          this.$emit('closeDrawer');
        } else {
          this.$error({ message: this.$getErr('APP_CATCH_ERR') });
        }
      }
    },
    checkValidationStatus() {
      let isValid = true;
      if (!this.selectedDelayReason || !this.delayInHours) {
        this.$error({ message: 'Please fill all the fields' });
        isValid = false;
      }
      if (this.selectedDelayReason === 'Others' && !this.delayReasonComment) {
        this.$error({ message: 'Please fill the comment for delay' });
        isValid = false;
      }
      return isValid;
    },
  },
};
</script>

<style lang="scss" scoped>
.shipment-delay-f-right {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.warning-text {
  font-size: medium;
  color: #234357;
  font-weight: bold;
  letter-spacing: 0.5px;
}
.el-form.form-default.form-triple .el-form-item {
  width: 100%;
}
.el-form{
    margin-right: 0px !important;
}
.title{
    text-transform: uppercase;
    color: #234357;
    font-size: 1.2rem;
    font-family: 'OpenSans-Semibold';
}
</style>
